
















import * as rhoa from 'rhoa'
import propDoc from 'propdoc'
import Usage from '@pages/Top/Usage.vue'
import ComponentDocs from '@pages/Top/ComponentDocs.vue'

export default
  components:
    'usage': Usage
    'compnent-docs': ComponentDocs
  data: ->
    rhoaVersion: rhoa.VERSION
    docObjects: [
      {
        doc: propDoc.getDoc(rhoa.SmartLink)
        bin: """
          <p data-height="265" data-theme-id="0" data-slug-hash="yvBzWr" data-default-tab="html,result" data-user="isuke" data-embed-version="2" data-pen-title="SmartLink" class="codepen">See the Pen <a href="https://codepen.io/isuke/pen/yvBzWr/">SmartLink</a> by isuke (<a href="https://codepen.io/isuke">@isuke</a>) on <a href="https://codepen.io">CodePen</a>.</p>
        """
        sourceUrl: "https://github.com/isuke/rhoa/blob/v#{rhoa.VERSION}/src/components/SmartLink.vue"
      }
      {
        doc: propDoc.getDoc(rhoa.FlexibleImage)
        bin: """
          <p data-height="265" data-theme-id="0" data-slug-hash="QQLqXJ" data-default-tab="html,result" data-user="isuke" data-embed-version="2" data-pen-title="FlexibleImage" class="codepen">See the Pen <a href="https://codepen.io/isuke/pen/QQLqXJ/">FlexibleImage</a> by isuke (<a href="https://codepen.io/isuke">@isuke</a>) on <a href="https://codepen.io">CodePen</a>.</p>
        """
        sourceUrl: "https://github.com/isuke/rhoa/blob/v#{rhoa.VERSION}/src/components/FlexibleImage.vue"
      }
      {
        doc: propDoc.getDoc(rhoa.SingleSubmitButton)
        bin: """
          <p data-height="265" data-theme-id="0" data-slug-hash="bLbYGx" data-default-tab="js,result" data-user="isuke" data-embed-version="2" data-pen-title="SingleSubmitButton" class="codepen">See the Pen <a href="https://codepen.io/isuke/pen/bLbYGx/">SingleSubmitButton</a> by isuke (<a href="https://codepen.io/isuke">@isuke</a>) on <a href="https://codepen.io">CodePen</a>.</p>
        """
        sourceUrl: "https://github.com/isuke/rhoa/blob/v#{rhoa.VERSION}/src/components/SingleSubmitButton.vue"
      }
    ]
  mounted: ->
    hljs.initHighlightingOnLoad()



// WEBPACK FOOTER //
// ./node_modules/coffeelint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-pug-lint-loader?{"disallowBlockExpansion":null,"disallowClassAttributeWithStaticValue":true,"disallowClassLiterals":null,"disallowClassLiteralsBeforeAttributes":null,"disallowClassLiteralsBeforeIdLiterals":true,"disallowDuplicateAttributes":true,"disallowHtmlText":true,"disallowIdAttributeWithStaticValue":true,"disallowIdLiterals":null,"disallowIdLiteralsBeforeAttributes":true,"disallowMultipleLineBreaks":true,"disallowSpacesInsideAttributeBrackets":true,"disallowSpecificAttributes":null,"disallowSpecificTags":["b","i"],"disallowStringConcatenation":true,"disallowStringInterpolation":true,"disallowTagInterpolation":true,"disallowTemplateString":true,"disallowTrailingSpaces":true,"maximumLineLength":180,"maximumNumberOfLines":80,"requireClassLiteralsBeforeAttributes":null,"requireClassLiteralsBeforeIdLiterals":null,"requireIdLiteralsBeforeAttributes":null,"requireLineFeedAtFileEnd":true,"requireLowerCaseAttributes":true,"requireLowerCaseTags":true,"requireSpacesInsideAttributeBrackets":null,"requireSpecificAttributes":null,"requireStrictEqualityOperators":true,"validateAttributeQuoteMarks":null,"validateAttributeSeparator":{"separator":", ","multiLineSeparator":",/n  "},"validateDivTags":true,"validateLineBreaks":"LF"}!./src/pages/Top.vue